import React from 'react';
import { Texto } from '../Texto';
export const BlockTexto = ({ texto, align, fontSize, bold }) => (React.createElement(Texto, { texto: texto, align: align, fontSize: fontSize, bold: bold }));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockTexto.tsx
// module id = 234
// module chunks = 0